import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { updateSotrMeet } from 'actions/asyncActions';

import { strToDate, strToTime } from 'mappers/commonMapper';
import SotrMeetModal from './SotrMeetModal';

const getInitialValues = (values) => ({
    id: values.id,
    type: values.type,
    description: values.text,
    date: strToDate(values.date),
    time: {
        from: strToTime(values.timeFrom),
        to: strToTime(values.timeTo),
    },
    showInPlanner: values.filter.planer,
    ownEvent: values.filter.private
});

const isAllDay = ({ time: { from, to } }) => !from && !to;

@withAsyncActions({
    updateSotrMeet: updateSotrMeet
        .withSuccessHandler(props => props.close())
        .withOptions({ autoReset: true })
})
export default class EditSotrMeetModal extends Component {
    render() {
        const { modal, updateSotrMeet, change, params } = this.props;
        const initialValues = getInitialValues(params);

        return (
            <SotrMeetModal
                titleTranslate="calendar.edit_sotrmeet"
                change={change}
                meta={updateSotrMeet.meta}
                allday={isAllDay(initialValues)}
                initialValues={initialValues}
                formAction={updateSotrMeet}
                modal={modal} />
        );
    }
}
